import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  redirectTo?: string;
  showMessage?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  redirectTo = '/', 
  showMessage = true 
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Show a brief message before redirecting (optional)
    if (showMessage) {
      const timer = setTimeout(() => {
        navigate(redirectTo, { replace: true });
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      // Immediate redirect
      navigate(redirectTo, { replace: true });
    }
  }, [navigate, redirectTo, showMessage]);

  if (showMessage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="mb-6 rounded-full bg-warning/10 p-4 inline-block">
            <svg 
              className="w-12 h-12 text-warning" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" 
              />
            </svg>
          </div>
          
          <h2 className="text-2xl font-bold mb-4">Access Restricted</h2>
          <p className="text-muted-foreground mb-6">
            Direct access to this directory is not allowed. You will be redirected to the home page.
          </p>
          
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default ProtectedRoute;